<template>
     <div>
        <!-- <div class="func" v-if="can_edit">
            <input class="number-input"  @focus="addflag = false" @input="addflag = false" @keyup.enter="addNumber" v-model.trim="task_number" ref="union-input"  placeholder="添加任务编号">
            <div class="front-btn" @click="addNumber">添加</div>
            <transition name="fade">
                <div class="func-tip" v-show="addflag">{{ addTip }}</div>
            </transition>
        </div> -->
        <div class="wrap">
            <div class="routerlink" v-for="(item,index) in task_union" :key="item.id" >
                <!-- <a @click="openUnion(item.union_task_id)">
                    {{ item.union_number }} - {{item.union_task_name}}
                </a> -->
                <a>
                    {{ item.union_number }} - {{item.union_task_name}}
                </a>
                <!-- <span v-if="can_edit" class="del" @click.stop.prevent="delUnion(item.union_task_id,index)">删除
                </span> -->
                <!-- <span v-else-if="userJudge" class="del" @click.stop.prevent="delUnion2(item.union_task_id,index)">删除
                </span> -->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components:{
        },
        props:["detailData"],
        data(){
            return {
                // task_number: '',    //关联输入框
                // addflag: false,   //提示信息显示判断器
                // addTip: "",   //添加关联任务的提示信息
                task_union: [],  //关联任务的信息列表
            }
        },

        computed:{
            // task_id(){   //任务id
            //     let str = this.$route.params.task_id;
            //     return this.taskId || this.$crypto.decrypt(str);
            // },
        },

        watch:{
            detailData(detail){
                this.task_union = [...detail.task_union];
            }
        },
    }
</script>

<style lang="less" scoped>
    @import "~src/assets/less/var.less";
    @max-w:470px;

    .func{
        width:@max-w;
        font-size:0;
        .number-input{
            display:inline-block;
            width: 178px;
            border: 1px solid @border-c;
            border-radius: 3px;
            // padding: 10px 15px;
            padding:0 10px;
            transition: 0.3s;
            font-size:12px;
            line-height:30px;
            &:hover {
                border-color: @hover-c;
            }
            &:focus {
                border-color: @focus-c;
            }
        }
        .front-btn{
            margin-left:15px;
        }
        .func-tip{
            color:@red;
            display:inline-block;
            font-size:12px;
            margin-left:15px;
        }
    
    }

    .wrap{
        width:@max-w;
        height:128px;
        border:1px solid @border-c;
        box-sizing:border-box;
        border-radius:4px;
        margin-top:15px;
        padding:0 10px;

        .routerlink{
            background: #fafafa;
            border: 1px solid #e3e3e3;
            border-radius: 4px;
            font-size:12px;
            padding:4px 10px;
            margin-top:6px;
            &:last-child{
                margin-bottom: 10px;
            }
            span{
                float:right;
                cursor: pointer;
            }
        }

    }
</style>





// WEBPACK FOOTER //
// read-relation.vue?34bd9452